export const Tools = {
  search: {
    key: 'search',
    title: 'Search'
  },
  settings: {
    key: 'settings',
    title: 'Settings'
  },
  infographic: {
    key: 'infographic',
    title: 'Infographic'
  },
  fieldSettings: {
    key: 'fieldSetting',
    title: 'Field settings'
  },
  grid: {
    key: 'grid',
    title: 'Grid'
  },
  map: {
    key: 'map',
    title: 'Map'
  },
  filter: {
    key: 'filter',
    title: 'Filter'
  },
  share: {
    key: 'share',
    title: 'Share'
  },
  save: {
    key: 'copy',
    title: 'Export'
  },
  info: {
    key: 'info',
    title: 'Info'
  }
}
